/**
 * Páginas informativas (personalização, descontos, à medida)
 * Descontos: transforma a lista de texto "≥ 250€ | 3%" (conteúdo traduzido do template)
 * num gráfico em escada e realça a frase seguinte. Se o texto não tiver este formato, não faz nada.
 */
(function () {
    'use strict';

    function enhanceDiscountTable() {
        if (!document.body.classList.contains('page-descontos')) return;

        const paragraphs = document.querySelectorAll('.custom-content .rte p');
        paragraphs.forEach((p) => {
            if (p.textContent.indexOf('≥') === -1 || p.textContent.indexOf('|') === -1) return;

            const rows = p.innerHTML
                .split(/<br\s*\/?>/i)
                .map((line) => {
                    const tmp = document.createElement('div');
                    tmp.innerHTML = line;
                    const parts = tmp.textContent.split('|').map((s) => s.replace(/\s+/g, ' ').trim());
                    return parts.length === 2 && parts[0] && parts[1] ? { min: parts[0], pct: parts[1] } : null;
                });
            if (!rows.length || rows.some((r) => !r)) return;

            // Parágrafo anterior com o cabeçalho ("Valor com IVA | % Desconto")
            let head = null;
            const prev = p.previousElementSibling;
            if (prev && prev.tagName === 'P' && prev.textContent.indexOf('|') > -1 && prev.textContent.indexOf('≥') === -1) {
                const labels = prev.textContent.split('|').map((s) => s.trim());
                if (labels.length === 2) head = { el: prev, labels: labels };
            }

            // Gráfico em escada: % em cima, barra crescente, valor mínimo por baixo (mobile: barras horizontais)
            const wrap = document.createElement('div');
            wrap.className = 'rt-discounts';
            wrap.style.setProperty('--n', rows.length);

            function el(tag, cls, text) {
                const node = document.createElement(tag);
                if (cls) node.className = cls;
                if (text) node.textContent = text;
                return node;
            }

            if (head) wrap.appendChild(el('p', 'rt-discounts-caption', head.labels[1]));

            const grid = el('ul', 'rt-discounts-grid');
            grid.setAttribute('role', 'list');
            const mins = el('div', 'rt-discounts-mins');
            mins.setAttribute('aria-hidden', 'true');

            rows.forEach((row, i) => {
                const li = el('li', 'rt-discount');
                li.style.setProperty('--i', i);
                // Leitores de ecrã: "≥ 250€ – 3%"
                const sr = el('span', 'rt-sr', row.min + ' – ' + row.pct);
                const pct = el('span', 'rt-discount-pct', row.pct);
                const bar = el('span', 'rt-discount-bar');
                const min = el('span', 'rt-discount-min', row.min);
                [pct, bar, min].forEach((n) => n.setAttribute('aria-hidden', 'true'));
                li.append(sr, pct, bar, min);
                grid.appendChild(li);
                mins.appendChild(el('span', 'rt-discount-min', row.min));
            });
            wrap.append(grid, mins);

            if (head) wrap.appendChild(el('p', 'rt-discounts-caption rt-discounts-caption--bottom', head.labels[0]));

            p.replaceWith(wrap);
            if (head) head.el.remove();

            // Realça a 1.ª frase do parágrafo seguinte ("Os descontos são automaticamente aplicados...")
            const next = wrap.nextElementSibling;
            if (next && next.tagName === 'P' && next.firstChild && next.firstChild.nodeType === 3) {
                const text = next.firstChild.nodeValue;
                const m = text.match(/^(\s*[^.!?]+[.!?])(\s|$)/);
                if (m) {
                    const strong = el('strong', 'rt-lead', m[1].trim());
                    next.firstChild.nodeValue = text.slice(m[1].length);
                    next.insertBefore(strong, next.firstChild);
                }
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', enhanceDiscountTable);
    } else {
        enhanceDiscountTable();
    }
})();
